import { PaymentReportField } from "src/app/enums/Report/ReportField/Payment/PaymentReportField";
import { IReportSortDefinition } from "../Components/IReportSortDefinition";
import { DateRangeParameter } from "./DateRangeParameter";
import { BaseReportParameters } from "./BaseReportParameters";
import { ConsolidatedPaymentReportField } from "src/app/enums/Report/ReportField/Payment/ConsolidatedPaymentReportField";
import { PaymentReportVariant } from "src/app/enums/Report/ReportField/Payment/PaymentReportVariant";

const localStorageFormParametersProperty = 'PaymentReportParameters';

export class PaymentReportParameters extends BaseReportParameters {
  variant: PaymentReportVariant;
  reportGroup: PaymentReportField | ConsolidatedPaymentReportField;
  createdPosId: number;
  createdClerkId: number;
  paymentDateRange: DateRangeParameter;
  sort: IReportSortDefinition[];

  constructor() {
    super(localStorageFormParametersProperty);
  }

  protected getParameters(storedParameters: PaymentReportParameters) {
    this.variant = <PaymentReportVariant>(storedParameters?.variant ?? PaymentReportVariant.Consolidated);
    this.reportGroup = storedParameters?.reportGroup ?? ConsolidatedPaymentReportField.None;
    this.createdPosId = storedParameters?.createdPosId ?? -1;
    this.createdClerkId = storedParameters?.createdClerkId ?? -1;
    this.paymentDateRange = new DateRangeParameter(storedParameters?.paymentDateRange);
  }
}
